import React, { Component } from 'react';
/* eslint-disable */
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

class RecruiterSidebarContent extends Component {
	static propTypes = {
		onClick: PropTypes.func.isRequired,
	};

	justLogout = () => {
		localStorage.clear();
		this.props.history.push('/');
	};

	hideSidebar = () => {
		const { onClick } = this.props;
		onClick();
	};

	render() {
		return (
			<div className="sidebar__content">
				<ul className="sidebar__block">
					{/* <SidebarLink
						title="Faq's"
						icon="list"
						route="/faqtechview"
						onClick={this.hideSidebar}
					/> */}
					<SidebarLink
						title="Phone Screen"
						icon="list"
						route="/faqtechview"
						onClick={this.hideSidebar}
					/>
					<SidebarCategory title="Tech Tests" icon="layers">
						<SidebarLink
							title="Add Test"
							icon="list"
							route="/addtest"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Saved Tests"
							icon="list"
							route="/savetest"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Sent Tests"
							icon="user"
							route="/senttests"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Completed Tests"
							icon="list"
							route="/comtest"
							onClick={this.hideSidebar}
						/>
					</SidebarCategory>
					{/* <SidebarLink
						title="Tickets"
						icon="list"
						route="/mytickets"
						onClick={this.hideSidebar}
					/> */}
					{/* <SidebarLink title="Log Out" icon="exit" onClick={this.justLogout} /> */}
				</ul>
				<ul className="sidebar__block">
					{/* <SidebarCategory title="Custom Tests" icon="layers">
						<SidebarLink
							title="Add Custom Test"
							icon="list"
							route="/addcustomtest"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="UnSaved Test List"
							icon="list"
							route="/mycustoms"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Saved Test List"
							icon="list"
							route="/customsavedtest"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Sent Test List"
							icon="list"
							route="/customsenttest"
							onClick={this.hideSidebar}
						/>
						<SidebarLink
							title="Completed Custom Tests"
							icon="list"
							route="/cuscomtest"
							onClick={this.hideSidebar}
						/>
					</SidebarCategory> */}
				</ul>
			</div>
		);
	}
}

export default RecruiterSidebarContent;
